// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i8vm","list":"styles_list__3T6VE","disableSelection":"styles_disableSelection__F5pcb"};